import { IntlShape } from 'react-intl';

export const getCurrencySymbol = (intl: IntlShape, currency: string) => {
  const parts = intl.formatNumberToParts(0, { currency, style: 'currency' });

  for (const part of parts) {
    if (part.type === 'currency') {
      return part.value;
    }
  }

  return null;
};
